import { useEffect, useState } from 'react';
import uniqBy from 'lodash/uniqBy';
import { useSelector } from 'react-redux';
import { selectUserDataReducer } from '@Redux/selectors';
import { filteredRecipientListForBeneDropdown } from './utils';

type component = 'single' | 'multiple' | 'loading';
export type beneObject = {
  beneficiary_name: string;
  key: number;
  value: number;
  currency_code: string;
  country_code: string;
  account_type: string;
  nickname: string;
  full_name: string;
  bank_name?: any;
  bank_account_number?: any;
  bank_account_country: string;
  routing_code_value_1?: any;
  routing_code_type_1: string;
  relationship_code: string;
  card_number: string;
  card_holder_name?: any;
  card_expiry_date?: any;
  card_issuer_name?: any;
  routing_config_type: string;
  renderName: string;
  renderAccountNumber: string;
  renderIcon: any;
  masked_account_number?: string;
  maskedAccountNumber?: string;
  subtitle?: string;
  relationship_name: string;
  upper?: string;
  mobile_country_code?: string;
  mobile_number?: string;
  renderMobileNo?: string;
  proxy_type?: string;
  proxy_value?: string;
  proxy_label?: string;
  iconName?: any;
  payout_method_config?: {
    label?: string;
    note?: string;
  };
  beneficiary_id?: string;
  is_dha_beneficiary?: boolean;
};

export type IDashboardCalculatorData = {
  source_amount: number;
  source_currency: string;
  destination_amount: number;
  destination_currency: string;
};
export interface IAddRecipientProps {
  getPayeeList?: any;
}
export type recipientListData = {
  data: Array<beneObject>;
  type: component;
};

export const useGetRecipient = (
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  getPayeeList: any,
  changeScreenToAddBene: () => void,
  source_currency: string,
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  recentAddedBeneIdList: any
): any => {
  const [recipientList, setRecipientList] = useState<recipientListData>({
    data: [],
    type: 'loading'
  });
  const beneList: any = useSelector(selectUserDataReducer)?.beneListData;

  useEffect(() => {
    const fetchData = async () => {
      const data =
        !source_currency && beneList?.length > 0
          ? beneList
          : await getPayeeList(null, source_currency);
      //formate data here and render data based on the
      const dataToRender = filteredRecipientListForBeneDropdown(data);

      if (data.length === 0) changeScreenToAddBene();
      else if (data.length === 1) {
        setRecipientList({ data: dataToRender, type: 'single' });
      } else {
        let orderedList: beneObject[] = [];

        if (recentAddedBeneIdList.length > 0) {
          // we dont mutate redux store
          [...recentAddedBeneIdList].forEach(({ beneficiary_id }) => {
            const itemToPush = dataToRender.find(
              (bene_item: any) => bene_item.beneficiary_id === beneficiary_id
            );
            if (itemToPush) orderedList.unshift(itemToPush);
            orderedList = uniqBy([...orderedList, ...dataToRender], 'beneficiary_id');
          });
          setRecipientList({ data: orderedList, type: 'multiple' });
          return;
        }
        setRecipientList({ data: dataToRender, type: 'multiple' });
      }
    };
    fetchData();
  }, [source_currency, recentAddedBeneIdList]); // eslint-disable-line react-hooks/exhaustive-deps
  return recipientList;
};
